export { default as default } from "./createWorkerFunctionInBrowser.js";
